import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Body from './Components/BodyComp/body';
import Footer from './Components/MainComp/footer';
import NavComp from './Components/MainComp/nav';
import Login from './Components/LoginComp/login';
import Signup from './Components/LoginComp/signup';
import ContactUs from './Components/ContactComp/contactus';
import AboutUs from './Components/ContactComp/aboutus';
import AdminPanel from './Components/AdminComp/adminpanel';
import PrivateRoute from './Utils/PrivateRoute';
import UploadResource from './Components/ResourceComp/uploadresource'; // Import your component
import AdvanceSearch from './Components/BodyComp/advancesearch';

import TelegramButton from './Components/Whatsapp/TelegramButton'; // Import the TelegramButtoncomponent
import ResearchPaper from './Components/ResourcesComp/researchpaper';
import JournalArticle from './Components/ResourcesComp/journalarticle';
import EBooks from './Components/ResourcesComp/ebooks';
import ClinicalResource from './Components/ResourcesComp/clinicalresource';
import FAQs from './Components/FAQComp/faqs';
import TermsAndConditions from  './Components/FAQComp/termsandconditions';
import PrivacyAndPolicy from  './Components/FAQComp/privacyandpolicies';
import UserProfile from './Components/UserComp/userprofile';
import EarnPoint from './Components/UserComp/earnpoint';
import Feedback from './Components/Whatsapp/feedback';
import ForgotPassword from "./Components/LoginComp/ForgotPassword";

import Fonseka_optometry from './Components/ResourcesComp/fonseka_optometry';
import Binocular_vision from './Components/ResourcesComp/binocular_vision';
import Prakash_pradhan from './Components/ResourcesComp/prakash_pradhan';


 
import AnatomyAndPhysiology from './Components/ResourcesComp/anatomy-and-physiology';
import CataractsAndIOL from './Components/ResourcesComp/cataracts-and-IOL';
import Cornea from './Components/ResourcesComp/cornea'; 
import DifferentialDiagnosisAndSystemicDisease from './Components/ResourcesComp/differential-diagnosis-and-systemic-disease';
import EXaminationAndTesting from './Components/ResourcesComp/examination-and-testing'; 
import EyeInfectionsAndDiseases from './Components/ResourcesComp/eye-infections-and-diseases';
import GeneralOphthalmology from './Components/ResourcesComp/general-ophthalmology';
import Glaucoma from './Components/ResourcesComp/glaucoma';
import HistoricalResources from './Components/ResourcesComp/historical-resources';
import LowVision from './Components/ResourcesComp/low-vision';
import NeuroOphthalmology from './Components/ResourcesComp/Neuro-Ophthalmology';
import NursingAndAlliedHealth from './Components/ResourcesComp/nursing-and-allied-health';
import PatientEducation from './Components/ResourcesComp/patient-education';
import Perception from './Components/ResourcesComp/perception';
import RefractiveErrors from './Components/ResourcesComp/refractive-errors';
import Retina from './Components/ResourcesComp/retina';
import Surgery from './Components/ResourcesComp/surgery';
import Trauma from './Components/ResourcesComp/trauma';
import PediatricsAndStrabismus from './Components/ResourcesComp/pediatrics-and-strabismus';
import OpticsAndPhysics from './Components/ResourcesComp/optics-and-physics';


function App() {

  return (
    <Router>
      <NavComp />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/clinicalresource" element={<ClinicalResource />} />
        <Route path="/ebooks" element={<EBooks />} />
        <Route path="/journalarticle" element={<JournalArticle />} />
        <Route path="/researchpaper" element={<ResearchPaper />} />
        <Route path="/binocular_vision" element={<Binocular_vision />} />
        <Route path="/fonseka_optometry" element={<Fonseka_optometry />} />
        <Route path="/prakash_pradhan" element={<Prakash_pradhan />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/advancesearch" element={<AdvanceSearch />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacyandpolicies" element={<PrivacyAndPolicy />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        {/* Protected route for uploading a resource */}

        <Route path="/anatomy-and-physiology" element={ <AnatomyAndPhysiology />} />
        <Route path="/cataracts-and-IOL" element={ <CataractsAndIOL />} />
        <Route path="/cornea" element={ <Cornea />} />
        <Route path="/differential-diagnosis-and-systemic-disease" element={ <DifferentialDiagnosisAndSystemicDisease />} />
        <Route path="/examination-and-testing" element={ <EXaminationAndTesting />} />
        <Route path="/eye-infections-and-diseases" element={ <EyeInfectionsAndDiseases />} />
        <Route path="/general-ophthalmology" element={ <GeneralOphthalmology />} />
        <Route path="/glaucoma" element={ <Glaucoma />} />
        <Route path="/historical-resources" element={ <HistoricalResources />} />
        <Route path="/low-vision" element={ <LowVision />} />
        <Route path="/neuro-ophthalmology" element={ <NeuroOphthalmology />} />
        <Route path="/nursing-and-allied-health" element={ <NursingAndAlliedHealth />} />
        <Route path="/patient-education" element={ <PatientEducation />} />
        <Route path="/perception" element={ <Perception />} />
        <Route path="/refractive-errors" element={ <RefractiveErrors />} />
        <Route path="/retina" element={ <Retina />} />
        <Route path="/surgery" element={ <Surgery />} />
        <Route path="/trauma" element={ <Trauma />} />
        <Route path="/pediatrics-and-strabismus" element={ <PediatricsAndStrabismus />} />
        <Route path="/optics-and-physics" element={ <OpticsAndPhysics />} />


        <Route
          path="/uploadresource"
          element={
            <PrivateRoute>
              <UploadResource />
            </PrivateRoute>
          }
        />
             
        <Route
          path="/userprofile"
          element={
            <PrivateRoute>
                <UserProfile />
            </PrivateRoute>
          }
        />

       <Route
          path="/earnpoint"
          element={
            <PrivateRoute>
                <EarnPoint />
            </PrivateRoute>
          }
        />
          
                    
                     
                {/* Protected route for admin panel */}
                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />
      </Routes>
      <Footer />
            {/* WhatsApp Button is always visible */}
            <TelegramButton /> {/* Add WhatsApp button outside Routes */}
            <Feedback />
    </Router>
  );
}

export default App;




